<script>
    import { onDestroy } from "svelte";
    export let changeTo = "";

    if (changeTo && changeTo.length && !changeTo.includes(" ")){
        let cl = document.body.classList;
        for(let i=0;i<cl.length;i++) {
            if (cl[i].includes("theme-")) {
                cl.remove(cls);
            }
        }
        cl.add("theme-"+changeTo);
    }
    onDestroy(()=>{
        document.body.classList.remove("theme-"+changeTo);
    })
</script>